import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Button, Modal, ModalProps } from "@blacknut/react-sdk";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const FEEDBACK_TYPE = "nps";

const NPSModal = (
  props: ModalProps & {
    onClose: () => void;
    onSkipped: (type: string) => Promise<void>;
    onScore: (type: string, score: string) => Promise<void>;
  },
) => {
  const { onSkipped, onScore } = props;
  const { t } = useTranslation();
  const [score, setScore] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (score) {
      onScore(FEEDBACK_TYPE, `${score}`);
    }
  }, [onScore, score]);

  return (
    <Modal
      {...props}
      className={styles.modal}
      testID="NPSModal"
      buttons={[
        <Button
          variant="primary"
          key="ok"
          onClick={() => onSkipped(FEEDBACK_TYPE)}
          testID="confirm"
        >
          {t("buttons.skip")}
        </Button>,
      ]}
    >
      <h3 className={styles.title}>{t("feedback.nps.title")}</h3>
      <h4 className={styles.subtitle}>{t("feedback.nps.subtitle")}</h4>

      <div className={styles.scoreDescContainer}>
        <p className={styles.scoreDesc}>0 - {t("feedback.nps.notLikely")}</p>
        <p className={styles.scoreDesc}>10 - {t("feedback.nps.veryLikely")}</p>
      </div>

      <ul className={styles.list}>
        {[...Array(11)].map((_, i) => (
          <Focusable
            component="li"
            className={clsx([styles.item])}
            key={i}
            onClick={() => setScore(i)}
            onPressEnter={() => setScore(i)}
          >
            {i}
          </Focusable>
        ))}
      </ul>
    </Modal>
  );
};

export default NPSModal;
